<template>
  <BreadCrumb page="Beranda > Pendaftaran > Jadwal Asesmen"></BreadCrumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Jadwal Asesmen</h3>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>Dibawah ini adalah jadwal asesmen untuk Ananda. </p>
        <div class="table-data-sga">
          <div class="table-responsive">
            <table class="table table-striped ">
              <thead>
              <tr>
                <th scope="col">No formulir</th>
                <th scope="col">Nama Ananda</th>
                <th scope="col">Nama Orang Tua</th>
                <th scope="col"> Jadwal</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(anak,idx) in dataAnak" :key="idx">
                <td>{{anak.no_formulir}}</td>
                <td>{{anak.nama_anak}}</td>
                <td>{{anak.nama_ortu}}</td>
                <td>{{anak.hari}}, {{anak.tanggal_kelas}} {{anak.sesi_waktu}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
export default {
  name: "PageJadwalAssessment",
  components: {BreadCrumb},
  data:()=>({
    loading: false,
    response: '',
    message: '',
    success: false,
    tanggalkelas:'',
    anggota:'',
    timname:'',
    showmodal: false,
    dataAnak:[],
    idanak:'',
  }),
  methods:{
    doShowPilihanJadwal(idanak){
      this.idanak = idanak;
      this.showmodal = !this.showmodal;
    },
    getDataAnak(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataJadwalAssessment';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAnak = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },
  mounted() {
    this.getDataAnak();
  }
}
</script>

<style scoped>

</style>